import { HttpRequest } from '@angular/common/http';

import { interceptorExceptURL } from '../config/auth.config';

export function filterInterceptorRequest(req: HttpRequest<any>): boolean {
  return interceptorExceptURL.some(url => req.url.includes(url));
}
